import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { DocumentTitle, Link, PageHeader, Spinner } from "components/common";
import { Row, Col } from "components/bootstrap";
import AIManagementPageNavigation from "ai-management/AIManagementPageNavigation";
import useModelProviderConfig from "ai-management/hooks/useModelProviderConfig";
import ModelProviderConfigForm from "ai-management/components/ModelProviderConfigForm";
import AgentWorkflowRoutes from "aiagent/Routes";
const ModelProviderConfigPage = () => {
  const { t } = useTranslation("enterprise_ai");
  const { data, isLoading } = useModelProviderConfig();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("model_provider_config_page.document_title") }, /* @__PURE__ */ React.createElement(AIManagementPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("model_provider_config_page.title") }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "model_provider_config_page.description",
      components: { workflowsLink: /* @__PURE__ */ React.createElement(Link, { to: AgentWorkflowRoutes.WORKFLOWS }) }
    }
  ))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, isLoading && /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Spinner, null)), !isLoading && /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(ModelProviderConfigForm, { initialConfig: data }))));
};
export default ModelProviderConfigPage;
